import { Button } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

import { FindPasswordButton } from '../../basic/PasswordSettingRow/EditMode';
import { LeaveRequestButton } from './LeaveRequestButton';

interface LeaveModalFooterProps {
  hasRemainSettlementAmount: boolean;
  hasPassword: boolean;
  isDirty: boolean;
  email: string;
  handleClose: () => void;
}

export const LeaveModalFooter = ({
  hasRemainSettlementAmount,
  hasPassword,
  isDirty,
  email,
  handleClose,
}: LeaveModalFooterProps) => {
  const { t } = useTranslation();

  if (hasRemainSettlementAmount) {
    return <LeaveRequestButton />;
  }

  if (hasPassword) {
    return (
      <Button disabled={!isDirty} fullWidth variant="filled" color="red" size="md" type="submit">
        {t('탈퇴하기')}
      </Button>
    );
  }

  return (
    <FindPasswordButton
      email={email}
      fullWidth
      color="infgreen"
      size="md"
      variant="default"
      onSuccess={handleClose}
      type="button"
    >
      {t('비밀번호 발급받기')}
    </FindPasswordButton>
  );
};
